import axios from "axios";//原生的axios
//用来拦截用的
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
//创建一个单例
const http= axios.create({
 // axios中请求配置有baseURL选项，表示请求URL公共部分
//  baseURL: process.env.VUE_APP_BASE_API,
 baseURL: 'http://139.159.186.0:9127/officialWebsite',
//  baseURL: 'http://127.0.0.1:9127/officialWebsite',
  timeout:5000,//响应时间
  // headers:{"Content-Type":"application/json;charset=utf-8"},
})
 
//拦截器  -请求拦截
http.interceptors.request.use(config=>{
  //部分接口需要token
  let token=localStorage.getItem('token');
  if(token){
    config.headers.token=token;
    // config.headers ={
      // 'token':token
    // }
  }
  return config;
},err=>{
  return Promise.reject(err)
})
 
//拦截器  -响应拦截
http.interceptors.response.use(res=>{
  if(res.data.code===200){
    return res.data
  }else{
    return res.data
  }
},err=>{
  return err
});
 
//整体导出
export default http;
 


// WEBPACK FOOTER //
// ./src/api/index.js